import React, { useState, useEffect } from 'react';

const SOUNDS = {
    up: new Audio('https://assets.mixkit.co/active_storage/sfx/2000/2000-preview.mp3'),
    down: new Audio('https://codeskulptor-demos.commondatastorage.googleapis.com/GalaxyInvaders/bonus.wav')
};
SOUNDS.up.volume = 0.5;
SOUNDS.down.volume = 0.5;

const WholeClassCard = ({ onWholeClassUpdate, totalScore = 0 }) => {
    const [animate, setAnimate] = useState('');
    const [scoreMode, setScoreMode] = useState('default');

    useEffect(() => {
        if (animate) {
            const timer = setTimeout(() => setAnimate(''), 400);
            return () => clearTimeout(timer);
        }
    }, [animate]);

    const handleScoreClick = (delta) => {
        try {
            const audio = delta > 0 ? SOUNDS.up : SOUNDS.down;
            if (!audio.paused) audio.currentTime = 0;
            audio.play().catch(() => {});
        } catch (e) {}

        setAnimate(delta > 0 ? 'score-up-effect' : 'score-down-effect');
        setScoreMode('default');
        
        if (typeof onWholeClassUpdate === 'function') {
            onWholeClassUpdate(delta);
        }
    };

    return (
        <div className={`ct-student-card ct-whole-class-card ${animate}`} style={{ 
            position: 'relative', 
            background: 'rgba(239, 68, 68, 0.05)', 
            backdropFilter: 'blur(10px)', 
            border: '2px dashed rgba(239, 68, 68, 0.3)', 
            borderRadius: '16px',
            boxShadow: '0 8px 25px rgba(0,0,0,0.5)',
            display: 'flex', flexDirection: 'column', height: '100%', padding: '6px'
        }}>
            
            <div className="ct-score-badge" style={{ backgroundColor: '#ef4444', boxShadow: '0 0 10px #ef4444', color: '#fff', fontWeight: '900', width: '26px', height: '26px', fontSize: '0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', position: 'absolute', top: '6px', right: '6px' }}>
                {totalScore}
            </div>
            
            <div className="ct-avatar-area" style={{ flex: '1 1 0', minHeight: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10px', marginBottom: '5px', cursor: 'default' }}>
                <img src="https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/1f30d.png" alt="Tüm Filo" style={{ filter: 'drop-shadow(0 5px 10px rgba(0,0,0,0.5))', maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
            </div>
            
            <div className="ct-name-area" style={{ flex: '0 0 auto', textAlign: 'center', marginBottom: '10px' }}>
                <h6 className="ct-student-name" style={{ color: '#fca5a5', fontWeight: '900', textShadow: '0 0 10px rgba(239,68,68,0.5)', margin: 0, fontSize: '0.9rem', letterSpacing: '1px' }}>
                    TÜM FİLO
                </h6>
            </div>
            
            <div className="ct-btn-area" style={{ flex: '0 0 auto', display: 'flex', gap: '4px' }}>
                {scoreMode === 'default' && (
                    <>
                        <button onClick={() => setScoreMode('minus')} style={{ flex: 1, padding: '4px 0', background: 'rgba(239, 68, 68, 0.1)', color: '#fca5a5', border: '1px solid rgba(239, 68, 68, 0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold' }}>-</button>
                        <button onClick={() => setScoreMode('plus')} style={{ flex: 1, padding: '4px 0', background: 'rgba(16, 185, 129, 0.1)', color: '#6ee7b7', border: '1px solid rgba(16, 185, 129, 0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '1rem', fontWeight: 'bold' }}>+</button>
                    </>
                )}

                {scoreMode === 'plus' && (
                    <div style={{ display: 'flex', width: '100%', gap: '2px' }}>
                        {[1, 2, 3].map(val => (
                            <button key={val} onClick={() => handleScoreClick(val)} style={{ flex: 1, padding: '4px 0', background: 'rgba(16, 185, 129, 0.15)', color: '#6ee7b7', border: '1px solid rgba(16, 185, 129, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.8rem' }}>+{val}</button>
                        ))}
                        <button onClick={() => setScoreMode('default')} style={{ flex: 0.8, padding: '4px 0', background: 'rgba(100, 116, 139, 0.2)', color: '#94a3b8', border: '1px solid rgba(100, 116, 139, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.7rem' }}>✕</button>
                    </div>
                )}

                {scoreMode === 'minus' && (
                    <div style={{ display: 'flex', width: '100%', gap: '2px' }}>
                        {[1, 2, 3].map(val => (
                            <button key={val} onClick={() => handleScoreClick(-val)} style={{ flex: 1, padding: '4px 0', background: 'rgba(239, 68, 68, 0.15)', color: '#fca5a5', border: '1px solid rgba(239, 68, 68, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.8rem' }}>-{val}</button>
                        ))}
                        <button onClick={() => setScoreMode('default')} style={{ flex: 0.8, padding: '4px 0', background: 'rgba(100, 116, 139, 0.2)', color: '#94a3b8', border: '1px solid rgba(100, 116, 139, 0.4)', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.7rem' }}>✕</button>
                    </div>
                )}
            </div>
            
        </div>
    );
};

export default WholeClassCard;